import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  labelInitialValues,
  LabelTabs,
} from 'components/organisms/forms/label/LabelForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiIdentificationCard, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetLabel, usePutLabel } from 'services/labels';
import { ILabelForm } from 'services/labels/types';
import { useStateStorage } from 'store/state';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { useEnumToSelectOptions } from 'utils/components/inputs/select';
import { getLastPathname } from 'utils/navbar/getParentPathname';

const EditLabel = () => {
  const labelId = useParamId('label');
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const editLabel = usePutLabel();

  const { data: label, isLoading } = useGetLabel(labelId);

  const mutateOptions = useMutateOptions<ILabelForm>();

  const onEditLabel = async (
    values: ILabelForm,
    helpers: FormikHelpers<ILabelForm>
  ) => {
    await editLabel.mutateAsync(
      { id: labelId, ...middleware.label.formToQuery(values) },
      {
        ...mutateOptions(helpers),
        onSuccess: ({ id }) =>
          navigate(`/label/${id}/${getLastPathname(pathname)}`),
      }
    );
  };

  return (
    <Form.Label
      i18nextPrefix='label'
      initialValues={
        label
          ? middleware.label.queryToForm(label)
          : labelInitialValues
      }
      disableTabs={[
        LabelTabs.residenceCertificates,
        LabelTabs.contracts,
        LabelTabs.balance,
        LabelTabs.settlements,
        LabelTabs.reports,
        LabelTabs.advance,
        LabelTabs.statistics,
      ]}
      onSubmit={onEditLabel}
      status={{ isLoading }}
      customBackItem={
        <Button
          type='button'
          onlyIcon
          onClick={() => {
            label &&
              navigate(`/label/${labelId}/${getLastPathname(pathname)}`, {
                replace: true,
              });
          }}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiIdentificationCard />} />
        </Button>
      }
    />
  );
};

export default EditLabel;
